import { ModalContentType } from "../../../../types/modal";
import { ModalActionKey } from "../../../actions/ActionKeys";
import { ModalAction } from "../../../actions/modal";

export const content = (
  state: ModalContentType | null = null,
  action: ModalAction
): ModalContentType | null => {
  switch (action.type) {
    case ModalActionKey.SHOW_MODAL:
      return action.payload.content;
    case ModalActionKey.HIDE_MODAL:
      return null;
    default:
      return state;
  }
};
